import f from "../../funcs";
import AppError from "./AppError";
import langDictionary from "../lang/init";


const knownMessages = {};
const ApiError = AppError.extend("ApiError", {
    onInit(params) {
        this.response = f.isObject(params.response) ? params.response : {};
        this.result = f.isObject(this.response.result) ? this.response.result : {};

        this.code = this.result.code || this.response.code || this.response.error;
        let templateData = this.result.data || this.response.data || {};

        try { // Не JSON ли?
            templateData = JSON.parse(this.code);
            this.code = templateData.code;
        } catch (e) { // нет, не JSON
            // nothing to do
        }

        this.message = langDictionary.getError(this.code, templateData);

        system.remoteLog("api.error", this.message, {
            request: params.request,
            response: params.response,
            stack: new Error().stack
        });

        // по простбе Леши мы закрываем глаза на ошибки
        // ибо слишком часто валится

        let isUIError = (
            this.code
                && this.message
                && this.message != this.code
                && this.code != "ajax_error"
                && this.message != "undefined"
        );

        if ( window.localStorage && window.localStorage.getItem("dev") ) {
            isUIError = true;
        }

        this.isUIError = isUIError;

        if ( isUIError ) {
            knownMessages[this.message] = true;
            this.show();
        }

    }
});

ApiError.isUIError = function(err) {
    return err.message in knownMessages;
};

export default ApiError;
